import { render, staticRenderFns } from "./CarritoLateral.vue?vue&type=template&id=490362bc&scoped=true"
import script from "./CarritoLateral.vue?vue&type=script&lang=js"
export * from "./CarritoLateral.vue?vue&type=script&lang=js"
import style0 from "./CarritoLateral.vue?vue&type=style&index=0&id=490362bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490362bc",
  null
  
)

export default component.exports